import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelAd.mjs'

export default function PropertiesPaneAd(props) {
    return (
        <ComponentPropertiesPane
            controllers={
                <>
                    <Text prop="adTitle" />
                    <Text prop="adUserCode" />
                    <LongText prop="resume" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        //'Depend',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
